const HANDLE_SIZE = 10;
const HANDLE_OFFSET = -HANDLE_SIZE / 2;

export default {
    root: {
        position: 'relative',
        display: 'inline-block',
        cursor: 'crosshair',
        overflow: 'hidden',
        maxWidth: '100%',
    },
    image: {
        display: 'block',
        maxWidth: '100%',
        touchAction: 'manipulation',
    },
    selection: {
        position: 'absolute',
        boxSizing: 'border-box',
        cursor: 'move',
        boxShadow: '0 0 0 9999em rgba(0, 0, 0, 0.5)',
        border: '1px dashed rgba(255, 255, 255, 0.7)',
        touchAction: 'none',
    },
    handle: {
        position: 'absolute',
        width: HANDLE_SIZE,
        height: HANDLE_SIZE,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        border: '1px solid rgba(255, 255, 255, 0.7)',
        boxSizing: 'border-box',
    },
    handleNw: { top: HANDLE_OFFSET, left: HANDLE_OFFSET, cursor: 'nw-resize' },
    handleN: { top: HANDLE_OFFSET, left: '50%', marginLeft: HANDLE_OFFSET, cursor: 'n-resize' },
    handleNe: { top: HANDLE_OFFSET, right: HANDLE_OFFSET, cursor: 'ne-resize' },
    handleE: { top: '50%', right: HANDLE_OFFSET, marginTop: HANDLE_OFFSET, cursor: 'e-resize' },
    handleSe: { bottom: HANDLE_OFFSET, right: HANDLE_OFFSET, cursor: 'se-resize' },
    handleS: { bottom: HANDLE_OFFSET, left: '50%', marginLeft: HANDLE_OFFSET, cursor: 's-resize' },
    handleSw: { bottom: HANDLE_OFFSET, left: HANDLE_OFFSET, cursor: 'sw-resize' },
    handleW: { top: '50%', left: HANDLE_OFFSET, marginTop: HANDLE_OFFSET, cursor: 'w-resize' },
};
